/** Copy of "Pflichten und Rechte im Handwerk" for the quiz dashboard, the quiz tabs and the header menu on bidmio.de. */
export const DE_RIGHTS_SITE_QUIZ = {
  title: 'Pflichten und Rechte im Handwerk',
  description:
    'Sieben kurze Fragen, danach sehen Sie nur, was für Sie gilt: Handwerksrolle, Umsatzsteuer, E-Rechnung, Mitarbeiter und Verträge mit Kunden. Bei jedem Punkt steht die Quelle.',
  short: 'Pflichten und Rechte',
  menuLabel: 'Welche Pflichten und Rechte haben Sie im Handwerk?',
};
